export const mockTimelineSteps = [
  {
    id: 1,
    title: "Tamizaje / sospecha",
    date: "02 de marzo de 2026",
    status: "completed",
    gapText: "23 días",
  },
  {
    id: 2,
    title: "Confirmación de diagnóstico",
    date: "02 de marzo de 2026",
    warning: "4 meses tarde",
    status: "completed_warning",
    gapText: "23 días",
  },
  {
    id: 3,
    title: "Inicio de tratamiento",
    date: "No iniciado",
    status: "current",
  }
];

export const mockBlocks = [
  {
    id: "block-tamizaje",
    type: "phase",
    title: "Tamizaje / sospecha",
    date: "02 de marzo de 2026",
    status: "completed", // shows top right badge
    milestones: [
      {
        id: "m1",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "05 de febrero de 2026",
        primaryDateLabel: "Fecha de cumplimiento",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada con retraso",
        badgeType: "completed-delayed"
      },
      {
        id: "m2",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "23 de noviembre de 2027",
        primaryDateLabel: "Cumplido a tiempo",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada",
        badgeType: "completed"
      },
      {
        id: "m3",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "23 de noviembre de 2027",
        primaryDateLabel: "Cumplido a tiempo",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada",
        badgeType: "completed"
      }
    ]
  },
  {
    id: "block-inicio",
    type: "phase",
    title: "Inicio de tratamiento",
    date: "02 de marzo de 2026",
    status: "current", // Shows 'Está aquí'
    milestones: [
      {
        id: "m4",
        title: "Revisión de Resultados de Laboratorio",
        checked: false,
        primaryDateText: "Pendiente",
        primaryDateLabel: "",
        secondaryDateText: "02 de marzo de 2024",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Pendiente con retraso",
        badgeType: "pending-delayed",
        isDelayed: true // Makes secondary date red
      },
      {
        id: "m5",
        title: "Revisión de Resultados de Laboratorio",
        checked: false,
        primaryDateText: "Pendiente",
        primaryDateLabel: "",
        secondaryDateText: "02 de marzo de 2024",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Pendiente con retraso",
        badgeType: "pending-delayed",
        isDelayed: true
      },
      {
        id: "m6",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "05 de febrero de 2026",
        primaryDateLabel: "Fecha de cumplimiento",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada con retraso",
        badgeType: "completed-delayed",
      }
    ]
  },
  {
    id: "block-control",
    type: "cycle",
    title: "Control",
    cycles: [
      { label: "Ciclo 1", value: 1 },
      { label: "Ciclo 2", value: 2 },
      { label: "Ciclo 3", value: 3 },
      { label: "Ciclo 4", value: 4 }
    ],
    selectedCycle: 4,
    status: "completed",
    cycleStatusText: "Completado",
    dateText: "Completado el 6 de abril 2026",
    milestones: [
      {
        id: "m7",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "23 de noviembre de 2027",
        primaryDateLabel: "Cumplido a tiempo",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada",
        badgeType: "completed"
      },
      {
        id: "m8",
        title: "Imágenes Diagnósticas",
        checked: true,
        primaryDateText: "23 de noviembre de 2027",
        primaryDateLabel: "Cumplido a tiempo",
        secondaryDateText: "01 de enero de 2026",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Completada",
        badgeType: "completed"
      }
    ]
  },
  {
    id: "block-control-1",
    type: "phase",
    title: "Control (Ciclo 1)",
    status: "locked",
    subtitle: "Para llegara este hito el paciente debe finalizar el anterior",
    milestones: [
      {
        id: "m9",
        title: "Revisión de Resultados de Laboratorio",
        locked: true,
        primaryDateText: "Pendiente",
        secondaryDateText: "02 de marzo de 2024",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Pendiente",
        badgeType: "pending"
      },
      {
        id: "m10",
        title: "Revisión de Resultados de Laboratorio",
        locked: true,
        primaryDateText: "Pendiente",
        secondaryDateText: "02 de marzo de 2024",
        secondaryDateLabel: "Fecha Ideal",
        badge: "Pendiente",
        badgeType: "pending"
      }
    ]
  }
];
